import {get, post} from "../APIGateWay";

export async function getTrophies() {
    return await get({}, '/your-space/trophies')
}

export async function showTrophies(data) {
    return await post(data,'/your-space/trophies/read')
}
